<template>
  <div class="footerSet" >
   <div class="bgSet">
      <div class="itemSet">
          <ul>
            <li>
                <h4><a href="/landPageHome" target="_blank">产品服务</a></h4>
                <p><a href="/landPageExp" target="_blank">国际快递</a></p>
                <p><a href="/landPageAir" target="_blank">国际空运</a></p>
                <p><a href="/landPageFBA" target="_blank">FBA头程</a></p>
                <p><a href="/landPageLine" target="_blank">国际专线</a></p>
                <p><a href="/landPageSea" target="_blank">国际海运</a></p>
                <p><a>国际小包</a></p>
                <p><a href="/pickup/frontPickupCheck" target="_blank">国内取件</a></p>
            </li>
            <li>
              <h4><a href="/Special/query-page/index.htm">物流工具</a></h4>
                <p><a href="/Special/query-page/index.htm">国际快递查询</a></p>
                <p><a href="/bywiki/reportCode">报关代码查询</a></p>
                <p><a href="/bywiki/declareElements">申报要素查询</a></p>
                <p><a href="/bywiki/deliveryArea">送货地址查询</a></p>
                <p><a href="/bywiki/remoteArea">偏远地址查询</a></p>
                <p><a href="/bywiki/shipCompany">船运公司查询</a></p>
                <p><a href="/bywiki/stowFactor">积载因素查询</a></p>
                <p><a href="/bywiki/airportCode">机场三字码查询</a></p>
                <p><a href="/bywiki/heavyCharge">计费重计算器</a></p>
                <p><a href="/bywiki/exchangeRate">汇率换算器</a></p>               
            </li>
            <li>
              <h4><a href="/news.html">百运百科</a></h4>
                <p><a href="/newsList">百运头条</a></p>
                <p><a href="/news.html?type=tonggaonews">重要公告</a></p>
                <p><a href="/logInformate.html?type=wuliuzixun">物流资讯</a></p>
                <p><a href="/electricityInfor.html?type=waimaozixun">电商资讯</a></p>
                <p><a href="/logKnowledge.html?type=wuliuzhishi">物流百科</a></p>
                <p><a href="/foreignTrade.html?type=waimaobaike">外贸百科</a></p>
                <p><a href="/shareForeignTrade.html?type=tradeshare">外贸经验</a></p>
                <p><a href="/mailingExperience.html?type=mail">邮寄经验</a></p>
                
            </li>
            <li>
              <h4><a href="/aboutBy/aboutByCent" rel="nofollow">关于我们</a></h4>
                <p><a href="/aboutBy/aboutByCent" rel="nofollow">关于百运</a></p>
                <p><a href="/aboutBy/agent" rel="nofollow">代理合作</a></p>
                <p><a href="/aboutBy/joinUs" rel="nofollow">招贤纳士</a></p>
                <p><a href="/aboutBy/contact" rel="nofollow">联系我们</a></p>
            </li>
            <li>
              <h4><a href="/helpCenter" rel="nofollow">帮助中心</a></h4>
                <p><a href="/helpCenter?type=1" rel="nofollow">新手指南</a></p>
                <p><a href="/helpCenter?type=2" rel="nofollow">常用问题</a></p>
            </li>
            <li style="width:430px;">
              <div class="itemCode">
                <p><img src="/static/img/QRcode1.jpg" width="88px" alt="小程序在线查价"></p>
                <p>扫一扫</p>
                <p>小程序在线查价</p>
              </div>
              <div class="itemCode">
                <p><img src="/static/img/QRcode2.jpg" width="88px" alt="关注微信公众号 "></p>
                <p>扫一扫</p>
                <p>关注微信公众号 </p>
              </div>
              <div class="itemCode">
                <p><img src="/static/img/QRcode3.jpg" width="88px" alt="下载百运网APP"></p>
                <p>扫一扫</p>
                <p>下载百运网APP</p>
              </div>
              <div class="cl"></div>
              <div class="font16 marTop30 colBlack" style="text-align:center"><b><i class="fa marR5 colGray9">&#xe651;</i>24小时服务热线：400 926 8156</b></div>
            </li>
          </ul>
        </div>
        <div class="cl"></div>
        <div class="footLink" v-if="isIndex">
          <span>友情链接：</span>
            <ul class="link">
              <li v-for="(item, index) in linkList" :key="index">
                <a :href="item.LinkUrl" alt="百运网国际快递" title="百运网-跨境物流智能服务平台">{{item.LinkName}}</a>
              </li>
            </ul>
        </div>
      <div class="positionFooter1"><p>©2019 深圳市百运科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">粤ICP备14023066号-1</a></p></div>
   </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {fetch,post} from '../../../ask/axios'
    export default {

      data(){
          return{
            isIndex:true, //是否是首页
            linkList:[],
          }
      },
      created(){
        this.initPage();
        this.linkListApi();//友情链接接口
        console.log('this.$route.push ' + this.$route.path);
        
      },
      methods:{

        initPage(){
         const indexPage= this.$route.path
        if(indexPage == '/'){
          this.isIndex=true
        }else{
          this.isIndex=false
        }
        },
        //友情链接接口
        linkListApi(){
          let that = this;
          // let url=this.$api02+"/api/EbayCustomer/FriendLink/QueryList";
          let url=this.$api04 + "Basics/api/FriendLink/QueryList";
          post(url).then(function (res) {
            if(res.Results){
              that.linkList=res.Results
            }
          })
        },

      },

    }
</script>

<style lang="css" scoped>
  .footerSet{background:#fff;width:100% !important;margin-bottom:-35px;background-image:url('/static/img/bot.png');background-repeat:no-repeat;}
  .bgSet{background-image:url('/static/img/bot.png');background-repeat:no-repeat;background-size:400px 250px;background-position-x:900px;background-position-y: top;}
  .itemSet{width:1200px;margin:auto;padding:35px 0;overflow:hidden;}
  .itemSet ul li{float: left;width:1200px;margin:auto;text-align:left;width:150px;display: block;}
  .itemSet ul li h4{margin-bottom:10px;color:#000;font-size:17px;}
  .itemSet ul li h4 a{color:#000;}
  .itemSet ul li p a{font-size:12px;line-height:24px;color:#666;}
  .itemSet ul li p a:hover{color:#0C5ee4 ;}
  .itemCode{text-align:center;float:left;width:140px;}
  .itemCode img{text-align:center;margin: auto}

  .positionFooter1{text-align:center;margin:auto;width:100%;border-top:1px solid #ddd;line-height:40px;}
  .positionFooter1 a{color:#666;}
  .positionFooter1 a:hover{color:#0C5ee4;}
  .footLink{width:1200px;margin:0 auto;height:49px;border-top:1px solid #E7E7E7;}
  .footLink span{
     display: inline-block;
     height:47px;
     line-height:47px;
     float: left;
     font-size:13px;
     color:#4a4a4a;
     margin-right:10px;
     overflow: hidden;
   }
  .footLink .link{float: left;color:#4A4A4A; overflow: hidden;}
  .footLink .link li{float: left;line-height:49px;margin-right:30px; overflow: hidden;}
  .footLink .link li a{color:#858585;font-size:13px;}
</style>



// WEBPACK FOOTER //
// src/components/Reception/public/frontFooter.vue